import {
  InteractiveTileDataType,
  InteractiveTileType,
  SubCountTileType,
} from '@app-store'
import { SvgInfoIcon, SvgLongBar, Tooltip } from '@ui-kit'
import { buildSubCounts, getTotalFromObject } from '../../utils/helperFunctions'
import { DASHBOARD, INITIAL_SELECTED_TILES } from '../../utils/constants'

export const InteractiveTile = ({
  tileName,
  total,
  border,
  selected,
  name,
  hidden,
  subCountBg,
  onStatusCardClick,
  onSubCountClick,
  message,
  selectedTile,
  selectedSubCount,
  serviceWiseData,
}: InteractiveTileDataType) => {
  const finalSubCounts =
    typeof total === 'string' ? null : buildSubCounts(total)
  return !hidden ? (
    <div
      className={`min-w-[14rem] min-h-[5rem] px-2 rounded-t shadow-[6px_6px_54px_0px_rgba(0,0,0,0.05)]  cursor-pointer flex flex-col overflow-x-auto ${
        selectedTile === tileName ? selected : border
      } ${
        tileName !== DASHBOARD.ALL_CASES
          ? selectedTile === tileName
            ? `${selected} py-1`
            : `${border}  py-1`
          : 'bg-blue-50'
      }`}
      onClick={() => {
        if (tileName !== DASHBOARD.ALL_CASES && onStatusCardClick) {
          if (selectedTile === tileName) {
            onStatusCardClick('', total)
          } else {
            onStatusCardClick(tileName, total)
          }
        }
      }}
    >
      {tileName !== DASHBOARD.ALL_CASES ? (
        <TileItem1
          tileName={tileName}
          message={message}
          total={total}
          selectedTile={selectedTile}
          name={name ?? ''}
          selectedSubCount={selectedSubCount}
          serviceWiseData={serviceWiseData}
          subCountBg={subCountBg}
        />
      ) : (
        <TileItem2
          finalSubCounts={
            finalSubCounts as
              | {
                  label: string
                  value: string
                }[]
              | null
          }
          onSubCountClick={onSubCountClick}
          selectedSubCount={selectedSubCount}
        />
      )}
    </div>
  ) : null
}

const TileItem1 = ({
  tileName,
  message,
  total,
  selectedTile,
  name,
  selectedSubCount,
  serviceWiseData,
  subCountBg,
}: InteractiveTileType) => {
  const displayValue =
    typeof total === 'string'
      ? Number(total)
      : getTotalFromObject(total as Record<string, number>)
  return (
    <div className="flex flex-col justify-between min-h-[4.2rem]">
      <div className="flex items-center">
        <span className="text-sm font-primary font-medium text-accent-900">
          {tileName}
        </span>
        {message && (
          <span className="text-accent-500 text-xs ml-2 cursor-pointer">
            <Tooltip content={message}>
              <SvgInfoIcon />
            </Tooltip>
          </span>
        )}
      </div>
      <div className="flex items-center justify-between">
        <div className="text-[1.5rem] leading-none font-semibold text-accent-900">
          {displayValue}
        </div>
        {selectedSubCount &&
          INITIAL_SELECTED_TILES.includes(selectedTile ?? '') && (
            <div
              className={`text-xs ${subCountBg} px-1 py-1 rounded flex flex-col items-center`}
            >
              <span className="text-xs font-semibold  text-accent-700">
                {selectedSubCount}{' '}
              </span>
              <span className="text-xs font-semibold text-accent-900">
                {serviceWiseData?.[selectedSubCount]?.[name] ?? 0}
              </span>
            </div>
          )}
      </div>
    </div>
  )
}

const TileItem2 = ({
  finalSubCounts = [],
  onSubCountClick,
  selectedSubCount,
}: SubCountTileType) => {
  if (!finalSubCounts || !finalSubCounts.length) return null

  const columnCount = Math.ceil(finalSubCounts.length / 3)

  const columns = Array.from({ length: columnCount }, (_, colIndex) =>
    finalSubCounts.slice(colIndex * 3, colIndex * 3 + 3)
  )

  return (
    <div className="flex gap-6 my-auto">
      {columns.map((columnItems, colIndex) => (
        <div key={colIndex} className="flex items-start gap-6">
          {/* Column */}
          <div className="flex flex-col">
            {columnItems.map(({ label, value }) => (
              <button
                key={label}
                onClick={(e) => {
                  e.stopPropagation()
                  if (selectedSubCount === label) {
                    onSubCountClick?.('')
                  } else {
                    onSubCountClick?.(label)
                  }
                }}
                className={`grid grid-cols-[minmax(2.5rem,auto)_minmax(1.5rem,auto)] gap-3 items-center px-2 py-1 rounded
                  ${
                    selectedSubCount === label
                      ? 'bg-blue-100 font-bold'
                      : 'hover:bg-blue-100 font-medium'
                  }`}
              >
                <span className="text-xs  text-accent-700">{label}</span>
                <span className="text-xs text-accent-900">{value}</span>
              </button>
            ))}
          </div>

          {/* Divider */}
          {colIndex !== columnCount - 1 && (
            <div className="flex items-stretch my-auto">
              <SvgLongBar />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
